import React from 'react';
import PropTypes from 'prop-types';

import BaseSkeleton from 'components/Skeleton/BaseSkeleton';
import {
  ActionsRow,
  FieldGrid,
  HeaderContent,
  PageWrapper,
  SectionCard
} from './styled';

export default function FormScreenSkeleton({ fields, showActions }) {
  const safeFields = Array.from({ length: fields });

  return (
    <PageWrapper>
      <HeaderContent>
        <BaseSkeleton height={32} width="32%" />
        <BaseSkeleton height={16} width="18%" />
      </HeaderContent>

      <SectionCard>
        <FieldGrid>
          {safeFields.map((_, index) => (
            <BaseSkeleton key={index} height={52} />
          ))}
        </FieldGrid>

        {showActions ? (
          <ActionsRow>
            <BaseSkeleton height={44} width={140} />
            <BaseSkeleton height={44} width={140} />
          </ActionsRow>
        ) : null}
      </SectionCard>
    </PageWrapper>
  );
}

FormScreenSkeleton.propTypes = {
  fields: PropTypes.number,
  showActions: PropTypes.bool,
};

FormScreenSkeleton.defaultProps = {
  fields: 6,
  showActions: true,
};
